import { CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON } from '@yme/common/constants';
export const generateConfiguratorLink = (configuratorUrl, hashParams) => {
    if (!configuratorUrl) {
        return;
    }
    try {
        const url = new URL(configuratorUrl);
        if (url.searchParams.get(CONFIGURATOR_PARAM_NAME) !== CONFIGURATOR_PARAM_VALUE_ON) {
            url.searchParams.set(CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON);
        }
        url.hash = hashParams;
        return url.toString();
    }
    catch (error) {
        return;
    }
};
